<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="jobs-delivery-list-content-loading" class="vs-con-loading__container">
		<vx-card no-shadow card-border class="custom-height">
			<template slot="actions">
				<div class="flex flex-row justify-between">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('VisitPoints.AssignVisitPoints')"
						:text="$t('VisitPoints.AssignVisitPointToltip')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-plus"
							:disabled="assignedDeliveryJobs.length > 2"
							@click.prevent="resetTempDeliveryPointJobs()"
						></vs-button>
					</vx-tooltip>
				</div>
			</template>
			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<vs-table
					v-if="assignedDeliveryJobs.length"
					ref="table"
					v-model="selected"
					search
					:max-items="itemsPerPage"
					:data="assignedDeliveryJobs"
				>
					<template slot="thead">
						<vs-th sort-key="name">{{ $t("Identification") }}</vs-th>
						<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
					</template>
					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>
									<p class="product-name font-medium truncate">{{ tr }}</p>
								</vs-td>
								<vs-td class="whitespace-no-wrap">
									<feather-icon
										icon="Trash2Icon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-2"
										@click.stop="removeAssignedDeliveryJob(tr)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p v-else-if="activeAlert2">
					<vs-alert
						class="mt-2"
						style="overflow-y: auto"
						color="warning"
						:active.sync="activeAlert2"
						:title="$t('VisitPoints.AssignVisitPoints')"
					>
						{{ $t("ThereAreNoVisitPointsAvailable", {n: $t("DeliveryService").toLowerCase()}) }}
						<span class="text-inherit underline font-bold">
							<feather-icon class="cursor-pointer" icon="MapPinIcon" svgClasses="h-4 w-4" />
							{{ $t("See") + " " + $t("RouterSelection.VisitPoints") }}
						</span>
					</vs-alert>
				</p>
				<p v-else>
					{{ $t("VisitPoints.NoAssignedVisitPoints") }}
				</p>
				<slot name="alert-message"> </slot>
			</vue-perfect-scrollbar>
			<vs-popup
				:fullscreen="true"
				:title="$t('DeliveryPoints')"
				:active.sync="deliveryJobMounted"
				class="vs-popup--content-custom"
			>
				<div class="flex items-center justify-between w-full">
					<div class="flex items-center md:w-4/5">
						<template>
							<vs-dropdown vs-trigger-click class="cursor-pointer">
								<div
									class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
								>
									<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelectedDeliveryJob }}</span>
									<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
								</div>
								<vs-dropdown-menu style="z-index: 54000">
									<vs-dropdown-item @click="setSearchFieldDeliveryJob('Identification')">
										<span>{{ $t("ResourceModule.Table.Identification") }}</span>
									</vs-dropdown-item>
									<vs-dropdown-item @click="setSearchFieldDeliveryJob('GroupSearch')">
										<span>{{ $t("GroupSearch") }}</span>
									</vs-dropdown-item>
								</vs-dropdown-menu>
							</vs-dropdown>
						</template>
						<vs-input
							v-model="searchQueryDeliveryJob"
							icon="icon-search"
							icon-pack="feather"
							class="w-full md:w-1/2"
							:placeholder="$t('Teams.Form.Add') + ' ' + searchSelectedDeliveryJob"
						/>
					</div>
					<vs-button
						color="primary"
						type="border"
						icon-pack="feather"
						:title="isExpandedDelivery ? $t('CollapseEverything') : $t('ExpandAll')"
						:icon="isExpandedDelivery ? 'icon-minimize-2' : 'icon-maximize-2'"
						@click.prevent="toggleAllDelivery"
					></vs-button>
					<vs-button
						icon-pack="feather"
						icon="icon-check"
						:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
						:size="iconSize"
						@click.prevent="setAssignedDeliveryJob()"
						>{{ windowWidth > 620 ? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection") : null }}
					</vs-button>
				</div>
				<ListSelectedVisitPointsItemDelivery
					ref="visitPointsItemDeliveryJob"
					:visit_point_selected_delivery="getVisitPointDeliveryList"
					:searchQueryDelivery="searchQueryDeliveryJob"
					:showActions="false"
					:showChecked="true"
					:key="renderComponentJob"
					:activeTabProp="1"
					@getExpanded="getExpandedDelivery"
				></ListSelectedVisitPointsItemDelivery>
			</vs-popup>
		</vx-card>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ListSelectedVisitPointsItemDelivery from "@/components/optimization/visit-point/ListSelectedVisitPointsItemDelivery.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export default {
	mixins: [generalPurposeMixin],
	components: {
		VuePerfectScrollbar,
		ListSelectedVisitPointsItemDelivery,
	},
	props: {
		deliveryPointJobsIds: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			searchFieldShippingDeliveryJob: "Identification",
			searchQueryDeliveryJob: null,
			activeItem: false,
			tempDeliveryPointJobs: [],
			selected: [],
			deliveryJobMounted: false,
			itemsPerPage: 7,
			isMounted: false,
			isExpandedDelivery: false,
			activeAlert2: false,
			renderComponentJob: 0,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	mounted() {
		this.isMounted = true;
		if (
			this.deliveryPointJobsIds &&
			this.deliveryPointJobsIds.length > 0 &&
			this.assignedDeliveryJobs.length <= 0
		) {
			this.$store.commit("moduleOptimization/SET_ASSIGNED_DELIVERY_JOBS", this.deliveryPointJobsIds);
		}
	},
	computed: {
		assignedDeliveryJobs() {
			return this.$store.state.moduleOptimization.listSelectedDeliveryJobs;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		getVisitPointDeliveryList() {
			return this.getFilteredListJob(
				this.tempDeliveryPointJobs,
				this.searchQueryDeliveryJob,
				this.searchFieldShippingDeliveryJob
			);
		},
		searchSelectedDeliveryJob() {
			return this.$t(`${this.searchFieldShippingDeliveryJob}`);
		},
		visit_point_delivery_jobs() {
			return this.$store.state.moduleOptimization.standardInputList["deliveries"] === undefined ||
				this.$store.state.moduleOptimization.standardInputList["deliveries"] === "" ||
				this.$store.state.moduleOptimization.standardInputList["deliveries"] === null
				? []
				: this.$store.state.moduleOptimization.standardInputList["deliveries"];
		},
	},
	methods: {
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		showPopup(val) {
			this.deliveryJobMounted = val;
		},
		removeAssignedDeliveryJob(id) {
			this.$store.commit("moduleOptimization/REMOVE_ASSIGNED_DELIVERY_JOBS", id);
		},
		setAssignedDeliveryJob() {
			// Filtrar las filas seleccionadas marcadas como "checked"
			const selectedRowsJob = this.tempDeliveryPointJobs.filter((data) => data.checked);
			// Filtrar las filas que no están ya asignadas
			const newJobs = selectedRowsJob.filter(
				(job) => !this.assignedDeliveryJobs.some((assigned) => assigned === job.identification)
			);
			// Validar el límite de asignaciones permitidas
			const totalJobs = this.assignedDeliveryJobs.length + newJobs.length;
			const maxJobsAllowed = 3;
			if (totalJobs > maxJobsAllowed) {
				this.$vs.notify({
					color: "success",
					title: this.$t("RouterSelection.Step1Title"),
					text: this.$t("OnlyAMaximumOf3VisitPoints", {n: this.$t("DeliveryService").toLowerCase()}),
					time: 8000,
				});
				return;
			}
			// Actualizar las asignaciones en el estado
			this.$store.commit(
				"moduleOptimization/SET_ASSIGNED_DELIVERY_JOBS",
				selectedRowsJob.map(({identification}) => identification)
			);
			// Marcar el trabajo como desmontado
			this.deliveryJobMounted = false;
		},
		groupByOriginalIdentificationDelivery(items) {
			return items.reduce((acc, item) => {
				const key = item.original_identification;
				if (!acc[key]) {
					acc[key] = [];
				}
				acc[key].push(item);
				return acc;
			}, {});
		},
		// Método generalizado para búsqueda y filtrado
		getFilteredListDelivery(items, searchQuery, searchField) {
			const groupedItems = this.groupByOriginalIdentificationDelivery(items);
			if (!searchQuery || searchQuery.trim() === "") {
				return Object.entries(groupedItems);
			}
			const normalizedSearchQuery = searchQuery.trim().toLowerCase();
			const searchList = Object.entries(groupedItems).reduce((acc, [key, items]) => {
				let filteredItems;

				if (searchField === "Identification") {
					filteredItems = items.filter((item) =>
						item.identification.toLowerCase().includes(normalizedSearchQuery)
					);
					if (filteredItems.length) {
						acc.push([key, filteredItems]);
					}
				} else if (key.toString().toLowerCase().includes(normalizedSearchQuery)) {
					acc.push([key, items]);
				}
				return acc;
			}, []);
			return searchList;
		},
		getFilteredListJob(items, searchQuery, searchField) {
			const searchListJob = this.getFilteredListDelivery(items, searchQuery, searchField);
			if (searchListJob.length > 0) {
				this.toggleAllDelivery();
			}
			return searchListJob;
		},
		resetTempDeliveryPointJobs() {
			if (this.visit_point_delivery_jobs.length > 0) {
				this.tempDeliveryPointJobs = this.visit_point_delivery_jobs.map((point) => ({
					...point,
					checked: false,
				}));
				this.renderComponentJob++;
				this.deliveryJobMounted = true;
				this.activeAlert2 = false;
			} else {
				this.activeAlert2 = true;
			}
		},
		toggleAllDelivery() {
			this.$refs.visitPointsItemDeliveryJob.toggleAll();
		},
		getExpandedDelivery(val) {
			this.isExpandedDelivery = val;
		},
		setSearchFieldDeliveryJob(val) {
			this.searchFieldShippingDeliveryJob = val;
		},
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 450px;
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
</style>
